import { SystemUpgrade, SystemUpgradeState } from 'src/app/shared/services/ump';

import { Health } from './interface';

export interface GlobalState {
  isLoading: boolean;
  pickupOffline: boolean;
  pickupCodeOffline: string;
  health: Health;
  isSessionActive: boolean;
  systemUpgrade: SystemUpgrade;
  /**
   * UMP has answered at least once, so systemUpgrade.state is knowledge rather
   * than the initial assumption. Survives in localStorage, which is what tells a
   * plain restart (state known) apart from a cold boot (state unknown).
   * Client-side only.
   */
  upgradeStateKnown: boolean;
  /**
   * A FAILED upgrade this client cannot rule out having caused: either it
   * watched IN_PROGRESS turn into FAILED, or it had never read UMP before and
   * so cannot know an upgrade was not running. A FAILED reported on top of a
   * known-good state does not count. Client-side only.
   */
  witnessedUpgradeFailure: boolean;
}

export const initialGlobalState: GlobalState = {
  pickupOffline: false,
  pickupCodeOffline: '',
  isLoading: false,
  health: null,
  isSessionActive: false,
  systemUpgrade: {
    state: SystemUpgradeState.OPERATIONAL,
  },
  upgradeStateKnown: false,
  witnessedUpgradeFailure: false,
};
